import "./App.css";
import Navbar from "./Components/Navbar";
import Body from "./Components/Body";
import Background from "./Assets/Background";
import {
  createBrowserRouter,
  RouterProvider,
  
  Outlet,
} from "react-router-dom";
import About from "./Components/About";
import Projects from "./Components/Projects";

const Layout = () => {
  return (
    <>
      <Background></Background>
      <Navbar></Navbar>
      <Outlet></Outlet>
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Body/>,
      },

      {
        path: "/Projects",
        element: <Projects />,
      },

      {
        path: "/About",
        element: <About />,
      },
    ],
  },

 
]);

function App() {
  return (
    <>
     <RouterProvider router={router}/>
    </>
  );
}

export default App;
